import React from 'react';
import { useRouteError } from 'react-router-dom';
import NotFoundImage from '../../images/exception-screens/404.svg';
import Warning from '../../images/exception-screens/fatal-error.svg';
import GenericErrorView, {
  ReloadButton,
  HomeLink,
} from '../../components/exceptions';

const ErrorPage = () => {
  const error: any = useRouteError();

  if (error.status === 404) {
    return (
      <GenericErrorView
        imgUrl={NotFoundImage}
        alt="not found"
        header="Sorry, we can't find that page"
        description="The page you're looking for has either moved or doesn't exist."
        ActionComponent={HomeLink}
      />
    );
  }

  return (
    <GenericErrorView
      imgUrl={Warning}
      alt="error"
      header="Oops, there was an unexpected error"
      description="Reload the page to try again."
      ActionComponent={ReloadButton}
    />
  );
};

export default ErrorPage;
